/*
<div class="formfield">
<label>Kuvaile yhdellä virkkeellä, mitä yrityksenne/yhteisönne tekee</label>
<div class="info">
<span class="infoicon"></span>
<div class="infotext">
<p>infoteksti</p>
</div>
</div>
<p class="kuvaus">Tähän saa edelleen kuvausteksin.</p>
<p>[textarea area-815]</p>
</div>
*/


// select the form element with the class "wpcf7-form"
const form = document.querySelector('.wpcf7-form');

// check if the form element exists
if (form) {
  // select all icons inside the form
  const icons = form.querySelectorAll('.infoicon');

  // attach a click event listener to each icon
  icons.forEach(function (icon) {
    icon.addEventListener('click', function () {
      // get the parent element with the class "info"
      const parent = icon.closest('.info');

      // get the infotext element inside the parent element
      const infotext = parent.querySelector('.infotext');

      // toggle the display of the infotext element
      if (infotext.style.display === 'block') {
        infotext.style.display = 'none';
      } else {
        // select all elements with the class "infotext" inside the form
        const infotexts = form.querySelectorAll('.infotext');

        // hide all elements with the class "infotext"
        infotexts.forEach(function (text) {
          text.style.display = 'none';
        });

        // show the infotext element
        infotext.style.display = 'block';
      }
    });
  });

  // attach a click event listener to the form
  form.addEventListener('click', function (event) {
    // check if the target of the event is not an icon or an element with the class "infotext"
    if (!event.target.classList.contains('infoicon') && !event.target.classList.contains('infotext')) {
      // select all elements with the class "infotext" inside the form
      const infotexts = form.querySelectorAll('.infotext');

      // hide all elements with the class "infotext"
      infotexts.forEach(function (infotext) {
        infotext.style.display = 'none';
      });
    }
  });
}
